import { Page_Flexiblecontent_Blocks_List } from "graphql";
import { Button } from "components/Button";

export interface ListProps extends Page_Flexiblecontent_Blocks_List {
  className?: string;
}

const List = ({
  className,
  backgroundColor,
  variant,
  title,
  sectionCopy,
  itemRepeater,
}: ListProps) => {
  const hasItems = itemRepeater && itemRepeater.length > 0;

  const isPrice = variant === `prices`;
  const isLink = variant === `links`;
  const isBasic = variant === `basic`;

  return (
    <section
      className={`${
        className ? className : ``
      } w-full py-16 bg-${backgroundColor}`}
    >
      <div
        className={`${
          className ? className : ``
        } container mx-auto flex flex-col gap-6`}
      >
        {title ? (
          <h2 className={`text-left font-heading text-5xl text-dark`}>
            {title}
          </h2>
        ) : null}
        {sectionCopy ? (
          <div dangerouslySetInnerHTML={{ __html: sectionCopy }} />
        ) : null}

        {hasItems ? (
          <div className={`flex flex-col gap-2`}>
            {itemRepeater.map((item, index) => {
              const {
                title,
                content,
                backgroundColor,
                price,
                buttonType,
                link,
              } = item ?? {};
              return (
                <div
                  className={`flex flex-col gap-6 px-4 py-2 md:flex-row bg-${backgroundColor}`}
                  key={`${index}`}
                >
                  <div className={`flex w-full flex-col gap-1`}>
                    {title ? (
                      <p className={`text-lg font-bold`}>{title}</p>
                    ) : null}
                    {content ? (
                      <div dangerouslySetInnerHTML={{ __html: content }} />
                    ) : null}
                  </div>
                  {!isBasic && (
                    <div className={`flex w-fit flex-col self-center`}>
                      {isPrice && price ? (
                        <p className={`text-2xl font-bold`}>{price}</p>
                      ) : null}
                      {isLink && link ? (
                        <Button
                          className={`w-fit`}
                          variant={buttonType ?? `primary`}
                          href={link?.url ?? ``}
                          target={link?.target ?? ``}
                        >
                          {link?.title}
                        </Button>
                      ) : null}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default List;
